export default __webpack_public_path__ + "static/media/logo.d3465815.png";